module.exports = __webpack_public_path__ + "img/icon5.39095893.png";